import type { ReactNode } from 'react'

export type EditorialDocumentSection = {
  id: string
  title: string
  paragraphs: ReactNode[]
}

type EditorialDocumentProps = {
  title: string
  titleId: string
  eyebrow: string
  intro: ReactNode[]
  sections: EditorialDocumentSection[]
}

export const EditorialDocument = ({
  title,
  titleId,
  eyebrow,
  intro,
  sections,
}: EditorialDocumentProps) => (
  <article className="editorial-document" aria-labelledby={titleId}>
    <header className="editorial-document__hero">
      <div className="editorial-document__hero-inner">
        <p className="editorial-document__eyebrow">{eyebrow}</p>
        <h1 id={titleId}>{title}</h1>
        <div className="editorial-document__intro">
          {intro.map((paragraph, index) => <p key={index}>{paragraph}</p>)}
        </div>
      </div>
    </header>

    <div className="editorial-document__sections">
      {sections.map((section) => (
        <section key={section.id} className="editorial-document__section" aria-labelledby={section.id}>
          <h2 id={section.id}>{section.title}</h2>
          <div className="editorial-document__copy">
            {section.paragraphs.map((paragraph, index) => <p key={index}>{paragraph}</p>)}
          </div>
        </section>
      ))}
    </div>
  </article>
)
